export { ImageOverlayCollectionRenderer } from './ImageOverlayCollectionRenderer'
export type { ImageOverlayCollectionRendererProps } from './ImageOverlayCollectionRenderer'
